import { render } from "./Default.vue?vue&type=template&id=42e1ca2f"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
script.render = render

export default script